import React from 'react';
import { formatUserTravelProfile } from 'selectors/user.selectors';
import TravelInput from './input';

const config = {
  // General
  format: formatUserTravelProfile,
  emptyMessage: 'Please select a User',
  title: 'User Travel',
  component: props => (
    <TravelInput
      {...props}
      title="User Travel"
    />
  )
};

export default config;
